export default function appUrl(){
    const url = process.env.REACT_APP_MODE === 'prod' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV;
    return url
};
